module.exports = __webpack_public_path__ + "static/img/3.8525850.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/youxiji/3.jpg
// module id = H/Ji
// module chunks = 1